import React, { FC, memo } from "react";
import { Text } from "@lookiero/sty-psp-ui";
import { ButtonIcon } from "@lookiero/sty-psp-ui";
import { BasketIcon } from "../../../basketIcon/BasketIcon";
import { Header } from "../Header";

interface HeaderProps {
  readonly title: string;
  readonly hasBasketNotification: boolean;
  readonly onBack: () => void;
  readonly onPressCart: () => void;
}

const WishlistHeader: FC<HeaderProps> = ({ title, onPressCart, onBack, hasBasketNotification }) => (
  <Header testID="whishlist-header">
    <ButtonIcon name="arrow_left" testID="arrow-left-button-icon" onPress={onBack} />
    <Text ellipsizeMode="tail" level={3} numberOfLines={1} style={{ flexShrink: 1 }} variant="action">
      {title}
    </Text>
    <BasketIcon notification={hasBasketNotification} testID="wishlist-go-basket" onPress={onPressCart} />
  </Header>
);

const MemoizedWishlistHeader = memo(WishlistHeader);

export { MemoizedWishlistHeader as WishlistHeader };
